import type { VRisingProfileNamespace } from "../graphql";
import type { ConfigSection, GameProfile, ProfileCtx } from "./types";
import vRising from "./vRising";

function buildConfigSections(ctx: ProfileCtx): ConfigSection[] {
  const sections: ConfigSection[] = [
    { component: "ConfSection", props: { name: "basic" } },
    { component: "BroadcastMessages" },
    { component: "ConfSection", props: { name: "extended" } },
    { component: "ConfSection", props: { name: "pvpSettings" } },
    { component: "ConfSection", props: { name: "castleStatModifier" } },
    { component: "TableSection", props: { name: "vBloodUnitSettings" } },
    { component: "TableSection", props: { name: "unlockedAchievements" } },
    { component: "TableSection", props: { name: "unlockedResearch" } },
  ];

  const profile = ctx.profile as VRisingProfileNamespace | undefined;
  const isOfficialServer = profile?.isOfficialServer;
  sections.unshift({
    component: "VRisingServerSetup",
    props: { gloomrotOnly: false, isLaunchServer: true, isOfficialServer },
  });

  return sections;
}

export default (ctx: ProfileCtx): Partial<GameProfile> => ({
  menu: vRising(ctx).menu,
  configSections: buildConfigSections(ctx),
});
